export default __webpack_public_path__ + "static/img-5-f49b97f42370598ba257847e78d6b383.png";